import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  required,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  DatePicker,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import PROVINCE from "../../assets/files/th_province.json";
import { formatNumber } from "../../utils/formatting";

export default class Customers extends Component {
  isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_region: "",
      filter_status: "",
      
      count: 0,
      page: 1,

      // Modal States
      modal_create: false,
      modal_update: false,
      modal_view: false,
      
      // Form States (อิงตาม API Payload)
      uid: "", // สำหรับระบุ ID ตอนแก้ไข/ลบ
      company_id: company?.id, // อิงตาม curl
      company_code: "", // -> customer_code
      name_th: "", // -> full_name_th
      name_en: "", // -> full_name_en
      alias: "", // -> alias_name
      customer_type: "นิติบุคคล", // -> type
      customer_group: "", // -> group
      tax_id: "", // -> tax_number
      branch_type: "สำนักงานใหญ่", // -> branch_type (สำนักงานใหญ่ / สาขา)
      branch_code: "", // -> branch_code
      delivery_zone: "", // -> delivery_zone
      start_date: "", // -> active_start_date
      source: "", // -> source
      image: "", // -> image
      address: "", // -> address
      province: "", // -> province
      district: "", // -> district
      sub_district: "", // -> sub_district
      zipcode: "", // -> zip_code
      phone_number: "", // -> phone
      phone_number_2: "", // -> phone
      fax: "", // -> fax
      mobile: "", // -> mobile_phone
      email: "", // -> email
      website: "", // -> website
      payment_method: "", // -> payment_type
      payment_terms: "", // -> payment_terms
      currency: "THB - บาทไทย", // -> currency
      priority_id: "", // -> priority_id
      travel_rate_per_trip: "", // -> travel_rate_per_trip
      account_owner: "", // -> account_owner
      note: "", // -> remark
      customer_status: "active", // -> customer_status (Active / HOLD / Inactive)
      status: "active", // -> is_active (boolean)

      // ข้อมูลสำหรับ Modal View
      contact_prefix: "",
      contact_first_name: "",
      contact_last_name: "",
      contact_position: "",
      contact_phone: "",
      contact_email: "",
      
      company: null,

      data: [],
      data_priorities: [],
    };
  }

  async componentDidMount() {
    await Promise.all([this.Get(1), this.GetPriorities()]);
  }

  // ดึงข้อมูลลูกค้า
  Get = async (page) => {
    const { filter_search, filter_status } = this.state;
    loading(true);

    let [result] = await Promise.all([ 
      GET("admin/customers", { 
        page_size: 10, 
        page: page, 
        data_search: filter_search || "",
        is_active: filter_status || "",
      }),
    ]);

    if (result?.status) {
      this.setState({ 
        data: result.data || [], 
        count: result.pagination?.count || 0,
        page: page
      });
    }

    loading(false);
  };

  GetPriorities = async () => {
    const result = await GET("admin/work-requisition/priorities", { page: 0, page_size: 10000 });
    if (result?.status) {
      this.setState({
        data_priorities:
          result.data?.map((item) => ({
            ...item,
            value: item.uid,
            label: this.getPriorityDisplayLabel(item),
          })) || [],
      });
    }
  };

  // สร้างหรือแก้ไขข้อมูลลูกค้า
  CreateUpdate = async () => {
    const {
      uid, company_id, company_code, name_th, name_en, alias, customer_type, customer_group,
      tax_id, branch_type, branch_code, delivery_zone, start_date, source, image, address, province, district, sub_district, zipcode,
      phone_number, phone_number_2, fax, mobile, email, website, payment_method, payment_terms, currency, priority_id,
      travel_rate_per_trip, account_owner, note, customer_status, contact_prefix, contact_first_name, contact_last_name, contact_position, contact_phone, contact_email
    } = this.state;
    const normalizedEmail = (email || "").trim();
    const normalizedContactEmail = (contact_email || "").trim();
    
    // Validate เบื้องต้น
    if (!name_th?.trim()) {
      alert("", "warning", t("warning"), t("validate_customer_name_th"));
      return;
    } else if(!customer_type) {
      alert("", "warning", t("warning"), t("validate_customer_type"));
      return;
    } else if(!address?.trim()) {
      alert("", "warning", t("warning"), t("validate_customer_address"));
      return;
    } else if(!province?.trim()) {
      alert("", "warning", t("warning"), t("validate_customer_province"));
      return;
    } else if(!this.state.modal_update && !phone_number?.trim()) {
      alert("", "warning", t("warning"), t("validate_customer_phone"));
      return;
    } else if (!this.state.modal_update && !contact_first_name?.trim()) {
      alert("", "warning", t("warning"), t("validate_contact_first_name"));
      return;
    } else if (!this.state.modal_update && !contact_phone?.trim()) {
      alert("", "warning", t("warning"), t("validate_contact_phone"));
      return;
    } else if (!priority_id?.trim()) {
      alert("", "warning", t("warning"), t("validate_priority"));
      return;
    } else if (normalizedEmail && !this.isValidEmail(normalizedEmail)) {
      alert("", "warning", t("warning"), t("invalid_email_address"));
      return;
    } else if (normalizedContactEmail && !this.isValidEmail(normalizedContactEmail)) {
      alert("", "warning", t("warning"), t("invalid_email_address"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // โหมดแก้ไข: ช่องที่ลบจนว่างต้องส่ง "-" (api.js แปลงเป็น "") ไม่งั้น key ว่างโดนตัดทิ้งแล้วค่าเดิมค้าง
      const clearable = (v) => (this.state.modal_update ? v || "-" : v);
      // Map state ให้ตรงกับ API Payload
      let body = {
        company_id: company_id,
        customer_code: company_code,
        full_name_th: name_th,
        full_name_en: clearable(name_en),
        alias_name: clearable(alias),
        type: customer_type,
        group: clearable(customer_group),
        tax_number: clearable(tax_id),
        branch_type: branch_type,
        branch_code: clearable(branch_code),
        delivery_zone: clearable(delivery_zone),
        active_start_date: start_date,
        source: clearable(source),
        image: image,
        address: address,
        province: province,
        district: clearable(district),
        sub_district: clearable(sub_district),
        zip_code: clearable(zipcode),
        // โหมดแก้ไข 3 ช่องนี้ไม่บังคับ: ลบค่าแล้วส่ง "-" (api.js แปลงเป็น "") ไม่งั้น key ว่างโดนตัดทิ้งแล้วค่าเดิมค้าง
        phone: this.state.modal_update ? phone_number || "-" : phone_number,
        phone_2: clearable(phone_number_2),
        fax: clearable(fax),
        mobile_phone: clearable(mobile),
        email: clearable(normalizedEmail),
        website: clearable(website),
        payment_type: clearable(payment_method),
        payment_terms: clearable(payment_terms),
        currency: currency,
        priority_id: priority_id,
        travel_rate_per_trip: travel_rate_per_trip === "" ? null : Number(travel_rate_per_trip),
        account_owner: clearable(account_owner),
        remark: clearable(note),
        customer_status: customer_status,
        is_active: customer_status === "inactive" ? false : true,
        // ข้อมูลสำหรับ Modal View (ถ้า API รองรับ)
        contact_prefix: clearable(contact_prefix),
        contact_first_name: this.state.modal_update ? contact_first_name || "-" : contact_first_name,
        contact_last_name: clearable(contact_last_name),
        contact_position: clearable(contact_position),
        contact_phone: this.state.modal_update ? contact_phone || "-" : contact_phone,
        contact_email: clearable(normalizedContactEmail)
      };

      let result = !uid
        ? await POST("admin/customers", body)
        : await PUT("admin/customers/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page); // โหลดข้อมูลใหม่
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  // ลบข้อมูลลูกค้า
  Delete = async (id) => {
    if(!id) return;
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("admin/customers/" + id, null);
      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_update: false });
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("cannot_delete_item"));
      }
      loading(false);
    }
  };

  // ฟังก์ชันช่วยจัดการข้อมูลตอนกดเปิด Modal แก้ไข
  handleEditClick = (item) => {
    this.setState({ 
      modal_update: true, 
      uid: item.uid || item.id, // ขึ้นอยู่กับ API ส่งอะไรมาเป็น PK
      company_code: item.customer_code || "",
      name_th: item.full_name_th || "",
      name_en: item.full_name_en || "",
      alias: item.alias_name || "",
      customer_type: item.type || "นิติบุคคล",
      customer_group: item.group || "",
      tax_id: item.tax_number || "",
      branch_type: item.branch_type || "สำนักงานใหญ่",
      branch_code: item.branch_code || "",
      delivery_zone: item.delivery_zone || "",
      start_date: item.active_start_date || "",
      source: item.source || "",
      image: item.image || "",
      address: item.address || "",
      province: item.province || "",
      district: item.district || "",
      sub_district: item.sub_district || "",
      zipcode: item.zip_code || "",
      phone_number: item.phone || "",
      phone_number_2: item.phone_2 || "",
      fax: item.fax || "",
      mobile: item.mobile_phone || "",
      email: item.email || "",
      website: item.website || "",
      payment_method: item.payment_type || "",
      payment_terms: item.payment_terms || "",
      currency: item.currency || "THB - บาทไทย",
      priority_id: this.resolvePriorityId(item),
      travel_rate_per_trip: item.travel_rate_per_trip ?? "",
      account_owner: item.account_owner || "",
      note: item.remark || "",
      customer_status: item.customer_status || (item.is_active !== false ? "active" : "inactive"),
      status: item.is_active !== false ? "active" : "inactive",
      // ข้อมูลสำหรับ Modal View (ถ้า API ส่งมา)
      contact_prefix: item.contact_prefix || "",
      contact_first_name: item.contact_first_name || "",
      contact_last_name: item.contact_last_name || "",
      contact_position: item.contact_position || "",
      contact_phone: item.contact_phone || "",
      contact_email: item.contact_email || ""
    });
  }

  // ฟังก์ชันรีเซ็ต Form
  handleCreateClick = () => {
    this.setState({
      modal_create: true,
      uid: "",
      company_code: "", name_th: "", name_en: "", alias: "", customer_type: "นิติบุคคล", customer_group: "", tax_id: "", branch_type: "สำนักงานใหญ่", branch_code: "", delivery_zone: "", start_date: "", source: "", image: "",
      address: "", province: "", district: "", sub_district: "", zipcode: "", phone_number: "", phone_number_2: "", fax: "", mobile: "", email: "", website: "",
      payment_method: "", payment_terms: "", currency: "THB - บาทไทย", priority_id: "", travel_rate_per_trip: "", account_owner: "", note: "", customer_status: "active", status: "active",
      contact_prefix: "", contact_first_name: "", contact_last_name: "", contact_position: "", contact_phone: "", contact_email: "",
    });
  }

  getCurrentLang = () => localStorage.getItem("lang") || "TH";

  getCustomerDisplayName = (customer) => {
    const currentLang = this.getCurrentLang();
    if (currentLang === "EN") {
      return customer?.full_name_en || customer?.full_name_th || customer?.alias_name || customer?.customer_code || "-";
    }
    return customer?.full_name_th || customer?.full_name_en || customer?.alias_name || customer?.customer_code || "-";
  }

  getPriorityDisplayLabel = (priority) => {
    const currentLang = this.getCurrentLang();
    const priorityName = currentLang === "EN" ? priority?.name_en || priority?.name_th || "-" : priority?.name_th || priority?.name_en || "-";
    const responseTime = `${priority?.sla_response_time_start || "-"} ${priority?.sla_response_time_start_unit || ""}`.trim();
    const resolutionTime = `${priority?.sla_response_time_end || "-"} ${priority?.sla_response_time_end_unit || ""}`.trim();

    return `${priorityName} (${responseTime} - ${resolutionTime})`;
  }

  resolvePriorityId = (item) => {
    const { data_priorities } = this.state;
    const directPriorityId = item.priority_id || item.priority?.uid || "";
    if (directPriorityId) {
      return directPriorityId;
    }

    const legacyPriorityValue = item.sla_level || item.priority?.name_th || item.priority?.name_en || "";
    if (!legacyPriorityValue) {
      return "";
    }

    const matchedPriority = data_priorities.find(
      (priority) =>
        priority.uid === legacyPriorityValue ||
        priority.value === legacyPriorityValue ||
        priority.name_th === legacyPriorityValue ||
        priority.name_en === legacyPriorityValue ||
        priority.label === legacyPriorityValue
    );

    return matchedPriority?.uid || matchedPriority?.value || "";
  }

  getContractStatusT = (statusStr) => {
    if(statusStr === "active") return t("active");
    if(statusStr === "Expiring Soon") return t("expiring_soon");
    if(statusStr === "Expired") return t("expired");
    return statusStr;
  }

  render() {
    const { 
      data, count, filter_search, filter_region, filter_status, page,
      modal_create, modal_update, modal_view, company,
      // Form fields
      uid, company_code, name_th, name_en, alias, customer_type, customer_group, tax_id, branch_type, branch_code, delivery_zone, start_date, source,
      address, province, district, sub_district, zipcode, phone_number, phone_number_2, fax, mobile, email, website,
      payment_method, payment_terms, currency, priority_id, travel_rate_per_trip, account_owner, note, status, customer_status,
      contact_prefix,
      contact_first_name,
      contact_last_name,
      contact_position,
      contact_phone,
      contact_email,
      data_priorities
    } = this.state;
    const emailHasError = Boolean((email || "").trim()) && !this.isValidEmail(email || "");
    const contactEmailHasError = Boolean((contact_email || "").trim()) && !this.isValidEmail(contact_email || "");

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("customers")}</h3>
                        <div className="text-secondary text-14">{t("manage_customer_info")}</div>
                    </div>
                    {can("customers.create") ? (
                    <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.handleCreateClick}>
                        <span className="me-2 text-16">+</span> {t("add_customer")}
                    </button>
                    ) : null}
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <div className="position-relative flex-grow-1" style={{ maxWidth: "350px" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                            <input
                                type="text"
                                className="form-control ps-5 wpx-350"
                                placeholder={t("search_customers")}
                                value={filter_search}
                                onChange={(e) => this.setState({ filter_search: e.target.value })}
                                onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                            />
                        </div>
                        {/* Optional Filters */}
                        <Select
                            className="form-control wpx-150"
                            options={[
                                { value: "true", label: t("active") },
                                { value: "false", label: t("inactive") },
                            ]}
                            value={filter_status}
                            onChange={(e) => this.setState({ filter_status: e })}
                            placeholder={t("all_status")}
                            defaultLabel={t("all_status")}
                        />
                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                {t("filter")}
                            </button>
                            <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}>
                                {t("clear_all")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    {/* Customers Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-2 border-0">{t("customer")}</th>
                                    <th className="py-3 border-0">{t("contact")}</th>
                                    <th className="py-3 border-0">{t("location")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, idx) => (
                                        <tr key={idx} className="border-bottom border-light">
                                            <td className="py-3 px-2">
                                                <div className="d-flex align-items-center">
                                                    <div className={`wpx-40 hpx-40 rounded-3 d-flex align-items-center justify-content-center me-3 flex-shrink-0 bg-primary-light text-primary`}>
                                                        <span className="icon text-16">{"\uf007"}</span>
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark text-14">{this.getCustomerDisplayName(item)}</div>
                                                        <div className="text-secondary text-12">{item.customer_code || "-"}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="fw-bold text-dark text-14">{item.phone || item.mobile_phone || "-"}</div>
                                                <div className="text-secondary text-12">{item.email || "-"}</div>
                                            </td>
                                            <td>
                                                <div className="text-dark text-14">{item.province || "-"}</div>
                                                <div className="text-secondary text-12 text-truncate" style={{ maxWidth: "200px" }}>
                                                    {item.address || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                {item.is_active !== false ? (
                                                    <span className="badge bg-success-light text-success rounded-pill px-3 py-1 fw-bold text-10 border border-success">{t("active")}</span>
                                                ) : (
                                                    <span className="badge bg-secondary-light text-secondary rounded-pill px-3 py-1 fw-bold text-10 border border-secondary">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.setState({ company: item, modal_view: true })} />
                                                    {can("customers.update") ? (
                                                    <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.handleEditClick(item)} />
                                                    ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data.length} {t("of")} {formatNumber(count)} {t("customers_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.Get(p)} />
                </div>
            </div>

            {/* CREATE / UPDATE MODAL - REWORKED UI */}
            <Modal
                size="xl"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                // backdrop="static"
            >
                {/* Custom Header */}
                <div className="modal-header border-bottom bg-white d-flex justify-content-between align-items-center py-3 px-4">
                    <div className="d-flex align-items-center">
                        <span className="icon text-primary text-24 me-2">{"\uf0c0"}</span>
                        <h4 className="fw-bold mb-0 text-dark" style={{ color: "#2B3674" }}>
                            {t("customer_form_title")}
                        </h4>
                        <span className="text-primary mx-2">•</span>
                        <span className="text-primary fw-medium text-14">{modal_create ? t("create_new") : t("edit_data")}</span>
                    </div>
                    <div className="d-flex align-items-center">
                        {status === "active" ? (
                            <span className="badge bg-success-light text-success px-3 py-1 rounded-pill border border-success d-flex align-items-center">
                                <div className="rounded-circle bg-success me-1" style={{ width: "6px", height: "6px" }}></div> {t("active")}
                            </span>
                        ) : (
                            <span className="badge bg-secondary-light text-secondary px-3 py-1 rounded-pill border border-secondary d-flex align-items-center">
                                <div className="rounded-circle bg-secondary me-1" style={{ width: "6px", height: "6px" }}></div> {t("inactive")}
                            </span>
                        )}
                    </div>
                </div>

                <Modal.Body className="p-4" style={{ backgroundColor: "#F4F7FE" }}>
                    {/* Section 1: ข้อมูลทั่วไป */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("general_information")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("customer_code")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("customer_code_placeholder")}
                                        value={company_code}
                                        onChange={(e) => this.setState({ company_code: e.target.value })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("customer_name_th")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("customer_name_th_placeholder")}
                                        value={name_th}
                                        onChange={(e) => this.setState({ name_th: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("alias_name")}</label>
                                    <input type="text" className="form-control" placeholder={t("alias_name_placeholder")} value={alias} onChange={(e) => this.setState({ alias: e.target.value })} />
                                </div>
                                <div className="col-md-8">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("customer_name_en")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("customer_name_en_placeholder")}
                                        value={name_en}
                                        onChange={(e) => this.setState({ name_en: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("customer_type")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "นิติบุคคล", label: t("customer_type_corporate") },
                                            { value: "บุคคลธรรมดา", label: t("customer_type_individual") },
                                        ]}
                                        value={customer_type}
                                        onChange={(e) => this.setState({ customer_type: e })}
                                        placeholder={t("customer_type_corporate")}
                                        default={false}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("customer_group")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "VIP", label: t("customer_group_vip") },
                                            { value: "General", label: t("customer_group_general") },
                                        ]}
                                        value={customer_group}
                                        onChange={(e) => this.setState({ customer_group: e })}
                                        placeholder={t("please_select")}
                                        defaultLabel={t("please_select")}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <div className="mb-3">
                                        <label className="form-label text-12 fw-bold text-secondary mb-1">{t("tax_id")}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("tax_id_placeholder")}
                                            maxLength={13}
                                            value={tax_id}
                                            onChange={(e) => this.setState({ tax_id: e.target.value.replace(/\D/g, "") })}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4 mt-0">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("head_office_branch")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "สำนักงานใหญ่", label: t("head_office") },
                                            { value: "สาขา", label: t("branch") },
                                        ]}
                                        value={branch_type}
                                        onChange={(e) => this.setState({ branch_type: e })}
                                        placeholder={t("head_office")}
                                        default={false}
                                    />
                                </div>
                                <div className="col-md-4 mt-0">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("branch_code")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("branch_code")}
                                        maxLength={50}
                                        value={branch_code}
                                        onChange={(e) => this.setState({ branch_code: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4 mt-0">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("delivery_zone")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("delivery_zone")}
                                        maxLength={100}
                                        value={delivery_zone}
                                        onChange={(e) => this.setState({ delivery_zone: e.target.value })}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("customer_start_date")}</label>
                                    <DatePicker type="th" className="form-control" value={start_date ? start_date.split("T")[0] : ""} onChange={(val) => this.setState({ start_date: val })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("source")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "Sale", label: t("sale") },
                                            { value: "Marketing", label: t("marketing") },
                                        ]}
                                        value={source}
                                        onChange={(e) => this.setState({ source: e })}
                                        placeholder={t("please_select")}
                                        defaultLabel={t("please_select")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: ที่อยู่และการติดต่อ */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("address_and_contact")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("address")} <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder={t("customer_address_placeholder")}
                                        value={address}
                                        onChange={(e) => this.setState({ address: e.target.value })}
                                    ></textarea>
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("province")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control"
                                        options={PROVINCE.map(e => ({ value: e.th, label: e.th }))}
                                        value={province}
                                        onChange={(e) => this.setState({ province: e, district: "", sub_district: "", zipcode: "" })}
                                        placeholder={t("province")}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("district")}</label>
                                    <Select
                                        className="form-control"
                                        options={(PROVINCE.find(e => e.th === province)?.district || []).map(e => ({ value: e.th, label: e.th }))}
                                        value={district}
                                        disabled={!province}
                                        onChange={(e) => this.setState({ district: e, sub_district: "", zipcode: "" })}
                                        placeholder={t("district")}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("sub_district")}</label>
                                    <Select
                                        className="form-control"
                                        options={(PROVINCE.find(e => e.th === province)?.district?.find(e => e.th === district)?.sub_district || []).map(e => ({ value: e.th, label: e.th, code: e.code }))}
                                        value={sub_district}
                                        disabled={!district}
                                        onChange={(e, i) => this.setState({ sub_district: e, zipcode: i?.code ? String(i.code) : "" })}
                                        placeholder={t("sub_district")}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("postal_code")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("postal_code_placeholder")}
                                        maxLength={5}
                                        value={zipcode}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("phone_1")}
                                        {!modal_update && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("landline_placeholder")}
                                        maxLength={10}
                                        value={phone_number}
                                        onChange={(e) => this.setState({ phone_number: e.target.value.replace(/\D/g, "") })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("phone_2")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("landline_placeholder")}
                                        maxLength={10}
                                        value={phone_number_2}
                                        onChange={(e) => this.setState({ phone_number_2: e.target.value.replace(/\D/g, "") })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("fax")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("landline_placeholder")}
                                        maxLength={10}
                                        value={fax}
                                        onChange={(e) => this.setState({ fax: e.target.value.replace(/\D/g, "") })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("mobile_phone")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("mobile_placeholder")}
                                        maxLength={10}
                                        value={mobile}
                                        onChange={(e) => this.setState({ mobile: e.target.value.replace(/\D/g, "") })}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("email")}</label>
                                    <input
                                        type="email"
                                        className={`form-control${emailHasError ? " is-invalid" : ""}`}
                                        placeholder={t("contact_email_placeholder")}
                                        value={email || ""}
                                        onChange={(e) => this.setState({ email: e.target.value })}
                                    />
                                    {emailHasError && <div className="invalid-feedback">{t("invalid_email_address")}</div>}
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("website")}</label>
                                    <input type="text" className="form-control" placeholder={t("website_placeholder")} value={website} onChange={(e) => this.setState({ website: e.target.value })} />
                                </div>
                            </div>
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom mt-4" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("primary_contact")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("prefix")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "นาย", label: t("prefix_mr") },
                                            { value: "นาง", label: t("prefix_mrs") },
                                            { value: "นางสาว", label: t("prefix_ms") },
                                        ]}
                                        value={contact_prefix}
                                        onChange={(e) => this.setState({ contact_prefix: e })}
                                        placeholder={t("prefix")}
                                        default={false}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("first_name")} {!modal_update && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("first_name_placeholder")}
                                        value={contact_first_name}
                                        onChange={(e) => this.setState({ contact_first_name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("last_name")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("last_name_placeholder")}
                                        value={contact_last_name}
                                        onChange={(e) => this.setState({ contact_last_name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("position")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("position_placeholder")}
                                        value={contact_position}
                                        onChange={(e) => this.setState({ contact_position: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("phone")} {!modal_update && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("contact_phone_placeholder")}
                                        maxLength={10}
                                        value={contact_phone}
                                        onChange={(e) => this.setState({ contact_phone: e.target.value.replace(/\D/g, "") })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("email")}</label>
                                    <input
                                        type="email"
                                        className={`form-control${contactEmailHasError ? " is-invalid" : ""}`}
                                        placeholder={t("contact_email_placeholder")}
                                        value={contact_email || ""}
                                        onChange={(e) => this.setState({ contact_email: e.target.value })}
                                    />
                                    {contactEmailHasError && <div className="invalid-feedback">{t("invalid_email_address")}</div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: การตั้งค่าระบบ */}
                    <div className="card border-0 shadow-sm rounded-4 mb-2">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>
                                {t("system_settings")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("default_payment_method")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "โอนเงิน", label: t("transfer") },
                                            { value: "เครดิต", label: t("credit") },
                                        ]}
                                        value={payment_method}
                                        onChange={(e) => this.setState({ payment_method: e })}
                                        placeholder={t("please_select")}
                                        defaultLabel={t("please_select")}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("currency")}</label>
                                    <Select
                                        className="form-control"
                                        options={[
                                            { value: "THB", label: `THB - ${t("thai_baht")}` },
                                            { value: "USD", label: `USD - ${t("us_dollar")}` },
                                        ]}
                                        value={currency}
                                        onChange={(e) => this.setState({ currency: e })}
                                        placeholder={t("currency")}
                                        default={false}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("payment_terms")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("payment_terms")}
                                        value={payment_terms}
                                        onChange={(e) => this.setState({ payment_terms: e.target.value })}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("default_sla_level")} <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                        className="form-control"
                                        options={data_priorities}
                                        value={priority_id}
                                        onChange={(e) => this.setState({ priority_id: e })}
                                        placeholder={t("select_sla_level")}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("account_owner")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("account_owner")}
                                        value={account_owner}
                                        onChange={(e) => this.setState({ account_owner: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("travel_rate_per_trip")}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder={t("travel_rate_per_trip_placeholder")}
                                        value={travel_rate_per_trip}
                                        onChange={(e) => this.setState({ travel_rate_per_trip: e.target.value })}
                                    />
                                    <div className="text-secondary text-10 mt-1">{t("travel_rate_per_trip_desc")}</div>
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("note_additional")}</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder={t("customer_note_placeholder")}
                                        value={note}
                                        onChange={(e) => this.setState({ note: e.target.value })}
                                    ></textarea>
                                </div>

                                {/* Status */}
                                <div className="col-12 mt-2 border-top pt-4">
                                    <h6 className="fw-bold mb-1 d-flex align-items-center">
                                        <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                                    </h6>
                                    <div className="d-flex gap-4 mt-3">
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="uomStatus"
                                                id="statusActive"
                                                checked={customer_status === "active"}
                                                onChange={() => this.setState({ customer_status: "active", status: "active" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                                {t("active")}
                                            </label>
                                        </div>
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="uomStatus"
                                                id="statusHold"
                                                checked={customer_status === "hold"}
                                                onChange={() => this.setState({ customer_status: "hold", status: "active" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusHold">
                                                {t("hold")}
                                            </label>
                                        </div>
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="uomStatus"
                                                id="statusInactive"
                                                checked={customer_status === "inactive"}
                                                onChange={() => this.setState({ customer_status: "inactive", status: "inactive" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                                {t("inactive")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                {/* Custom Footer */}
                <Modal.Footer className="border-top p-3 bg-white d-flex justify-content-between">
                    <div>
                        {modal_update && can("customers.delete") && (
                            <button onClick={() => this.Delete(uid)} className="btn btn-outline-danger px-4 d-flex align-items-center bg-white border-danger text-danger">
                                <span className="icon me-2 text-14">{"\uf2ed"}</span> {t("delete_data")}
                            </button>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-outline-secondary px-4 bg-white" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            <span className="icon me-2 text-14">{"\uf00d"}</span> {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 d-flex align-items-center" onClick={this.CreateUpdate}>
                            <span className="icon me-2 text-14">{"\uf00c"}</span> {t("save")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* VIEW MODAL */}
            <Modal size="lg" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered>
                <Modal.Header className="border-bottom" closeButton>
                    <h5 className="fw-bold mb-0">{t("customer_details")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {company && (
                        <div>
                            <h5 className="fw-bold text-dark">{this.getCustomerDisplayName(company)}</h5>
                            <p className="text-secondary">{company.customer_code}</p>
                            <p>
                                <strong>{t("phone")}:</strong> {company.phone || company.mobile_phone}
                            </p>
                            <p>
                                <strong>{t("email")}:</strong> {company.email}
                            </p>
                            <p>
                                <strong>{t("address")}:</strong> {company.address} {company.province} {company.zip_code}
                            </p>
                            {company.alias_name && (
                                <p>
                                    <strong>{t("alias_name")}:</strong> {company.alias_name}
                                </p>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top bg-white p-3 d-flex justify-content-end">
                    <button className="btn btn-outline-secondary px-4 me-2" onClick={() => this.setState({ modal_view: false })}>
                        {t("close")}
                    </button>
                    {can("customers.update") ? (
                    <button
                        className="btn btn-primary px-4 d-flex align-items-center"
                        onClick={() => {
                            this.setState({ modal_view: false });
                            this.handleEditClick(company);
                        }}
                    >
                        <span className="icon me-2">{"\uf044"}</span> {t("edit")}
                    </button>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
